/**
 * LOGOS — React Error Boundary
 * 
 * Catches runtime errors in the component tree and displays
 * a recovery UI instead of a white screen.
 * 
 * @author Dr. José Manuel Cadena Ortiz de Montellano
 * @framework Cadena Strategic Systems
 */

import { Component } from 'react';
import i18n from '../i18n';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[LOGOS] Unhandled error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#0a0a0f',
          color: '#e2e8f0',
          fontFamily: 'system-ui, sans-serif',
          padding: 32,
          textAlign: 'center',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>Λ</div>
          <h1 style={{ fontSize: 20, fontWeight: 600, marginBottom: 8, color: '#8b5cf6' }}>
            {i18n.t('errorBoundary.title', 'LOGOS — Error Inesperado')}
          </h1>
          <p style={{ fontSize: 13, color: '#94a3b8', maxWidth: 400, lineHeight: 1.6, marginBottom: 24 }}>
            {i18n.t('errorBoundary.message', 'Algo salió mal en el motor de consciencia. Tu estado está guardado de forma segura.')}
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: '#8b5cf6',
              color: '#fff',
              border: 'none',
              borderRadius: 8,
              padding: '10px 24px',
              fontSize: 14,
              cursor: 'pointer',
              fontWeight: 500,
            }}
          >
            {i18n.t('errorBoundary.reload', 'Recargar LOGOS')}
          </button>
          {this.state.error && (
            <pre style={{
              marginTop: 24,
              fontSize: 10,
              color: '#64748b',
              maxWidth: 500,
              overflow: 'auto',
              padding: 12,
              background: '#111118',
              borderRadius: 8,
              border: '1px solid #1e1e2e',
              textAlign: 'left',
            }}>
              {this.state.error.toString()}
            </pre>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
